(function () {
    'use strict';
    var controllerId = 'cndPCorso4A';
    angular.module('app').controller(controllerId, ['common', '$scope', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '_', 'commonAttach', fn_cndPCorso4A]);

    function fn_cndPCorso4A(common, $scope, $rootScope, bDialog, $routeParams, modal, datacontext, sectionMenu, _, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'Percorsi Formativi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.ableIssue = true;
        vm.objName = "CNDCorso"; //Utilizzato per pannello authorization
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.risorsa = {};

        vm.confirm = {};
        vm.corsoMod = {};
        vm.corsoModSpec4A = {};

        vm.pageWizard = 1;
        vm.pageMaxWizard = 12;
        vm.lastPageWizard = vm.pageWizard;
        vm.pageWizardTitle = [];
        vm.setPageWizard = setPageWizard;
        vm.wizardCompleted = false;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.bMaxOre = true;

        //Elenco per Ordinamento

        vm.list = {};

        vm.getRecord = getRecord;
        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        //Elenchi dettaglio
        vm.list.attach = [];
        vm.tSourceCode_def = 'CRS_4A';
        vm.list.b_attach = false;

        vm.list.b_materie = false;
        vm.list.b_classi = false;

        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fTMisuraCode = '4A';
        vm.fPartecipazioneId = 0;
        vm.fAPLId = 0;
        vm.fIStato = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.tMisuraCode = vm.fTMisuraCode;
        vm.filter.partecipazioneId = vm.fPartecipazioneId;
        vm.filter.aplId = vm.fAPLId;
        vm.filter.iStato = vm.fIStato;

        vm.fAttach = {};
        vm.setfAttach = setfAttach;
        vm.filterAttach = '';
        vm.fAttach.TAttachId = '';

        //Elenchi per filtri e finestra modale di Create
        vm.tSource = {};
        vm.tAttach = [];

        vm.cmblist = {};

        vm.cmblist.APL = [];
        vm.cmblist.cndTRisorse = [];
        vm.cmblist.cndTAule = [];
        vm.cmblist.tAteco = [];
        vm.cmblist.tFigProfessionali = [];
        vm.cmblist.settProfessionali = [];
        vm.cmblist.tProfiloDocenti = [];
        vm.cmblist.tTitoloStudio = [];

        vm.cmblist.enti1 = [];
        vm.cmblist.enti2 = [];

        // #region Localizzazione

        vm.cmblist.paesi = [];
        vm.cmblist.province = [];
        vm.cmblist.tIndirizzi = [];
        vm.cmblist.comuni = [];

        vm.getPaesi = function () {
            if (vm.cmblist.paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi = data;
            });
        };
        vm.getProvince = function () {
            if (vm.cmblist.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = data;
            });
        };
        vm.getTIndirizzi = function () {
            if (vm.cmblist.tIndirizzi.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi = data;
            });
        };
        vm.getComuni = function () {
            if (vm.cmblist.comuni.length > 0) return;

            datacontext.arrComuni().then(function (data) {
                //console.info('getComune()', data);
                vm.cmblist.comuni = data;
            });
        };

        vm.cmblist.paesi_sedeSvolg = [];
        vm.cmblist.province_sedeSvolg = [];
        vm.cmblist.comuni_sedeSvolg = [];
        vm.cmblist.tIndirizzi_sedeSvolg = [];

        //-- SedeSvolg_PaeseId, SedeSvolg_ComuneId
        vm.change_Paesi_Svolg = function () {
            if (vm.record.SedeSvolg_PaeseId > 0) {
                vm.record.SedeSvolg_ComuneId = 0;
                vm.record.SedeSvolg_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_Svolg = function (idProv) {
            vm.record.SedeSvolg_ComuneId = '';
            vm.getComuni_Svolg(idProv);
        };
        vm.getComuni_Svolg = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeSvolg = [];
            if (vm.record.SedeSvolg_ProvinciaId != idprov) vm.cmblist.comuni_sedeSvolg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeSvolg = data;
            });
        };
        vm.getPaesi_Svolg = function () {
            if (vm.cmblist.paesi_sedeSvolg.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeSvolg = data;
            });
        };
        vm.getProvince_Svolg = function () {
            if (vm.cmblist.province_sedeSvolg.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeSvolg = data;
            });
        };
        vm.getTIndirizzi_Svolg = function () {
            if (vm.cmblist.tIndirizzi_sedeSvolg.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeSvolg = data;
            });
        };


        // #endregion

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;


        vm.goNext = goNext;
        vm.goPrev = goPrev;
        vm.PrevWizard = PrevWizard;
        vm.NextWizard = NextWizard;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.merge = mergeItem;
        vm.delete = deleteItem;

        vm.stepCompiled = stepCompiled;

        vm.pageWizardTitle.push('1 - DATI SINTESI DEL PROGETTO');
        vm.pageWizardTitle.push('2 - PROFILI PROFESSIONALI');
        vm.pageWizardTitle.push('3 - DATORI DI LAVORO');
        vm.pageWizardTitle.push('4 - SEDI');
        vm.pageWizardTitle.push('5 - DURATA ATTIVIT\xC0 E COSTI PREVISTI');
        vm.pageWizardTitle.push('6 - RISORSE DA IMPIEGARE NEL PROGETTO');
        vm.pageWizardTitle.push('7 - AULE DIDATTICHE-MULTIMEDIALI');
        vm.pageWizardTitle.push('8 - STRUMENTI E SUPPORTI PER LE ATTVIT\xC0');
        vm.pageWizardTitle.push('9 - PARI OPPORTUNIT\xC0 E NON DISCRIMINAZIONE');
        vm.pageWizardTitle.push('10 - ALLEGATO 3.3 - ELENCO PERSONALE DOCENTE');
        vm.pageWizardTitle.push('11 - ALLEGATO 3.2 - ELENCO ALLIEVI AMMESSI');
        vm.pageWizardTitle.push('12 - RIEPILOGO');


        vm.changeDurata = changeDurata;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
            else if (iOpened == 3) vm.opened3 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.DtStartPrev = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.DtEndPrev = '';
                vm.changed = true;
            }
            else if (iOpened == 3) {
                vm.record.M4A_DtPercorso = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [
                getAuthorization()
                , $rootScope.getRisorsa(vm)
                , getAPL()
                , getTRisorse()
                , getTAule()
                , getTAteco()
                , getTFigProfessionali()
                , getSettProfessionali()
                , getTProfiliDocenti()
                , getTTitoloStudio()
                , getTSource(vm.tSourceCode_def)
                , getTAttach(vm.tSourceCode_def)
                , getEnte1()
                , getEnte2()
                //Localizzazioni 
                , vm.getPaesi()
                , vm.getProvince()
                , vm.getComuni()
                , vm.getTIndirizzi()
                , vm.getPaesi_Svolg()
                , vm.getProvince_Svolg()
                , vm.getTIndirizzi_Svolg()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    vm.activated = true;
                    if ($routeParams.CNDPCorso4AId != null) {
                        setView('detail');
                        getRecord($routeParams.CNDPCorso4AId, 0);
                    }

                    cerca();
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.tMisuraCode = vm.fTMisuraCode == null ? '' : vm.fTMisuraCode;
            vm.filter.partecipazioneId = vm.fPartecipazioneId == null ? 0 : vm.fPartecipazioneId;
            vm.filter.aplId = vm.fAPLId == null ? 0 : vm.fAPLId;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;

            vm.loading = false;

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.pCorso_countAll(vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.pCorso_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato, "").then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function (data) {
                //Auth. specifica
                //vm.isSpecial = (vm.isSUPER || vm.isUMC || vm.isCIAPI);
            });
        }

        function setRecord(data, pageWiz) {
            vm.record = data;

            if (vm.record.DtStartPrev != null) vm.record.DtStartPrev = new Date(vm.record.DtStartPrev);
            if (vm.record.DtEndPrev != null) vm.record.DtEndPrev = new Date(vm.record.DtEndPrev);

            if (vm.record.SedeSvolg_TIndirizzoId == 0) vm.record.SedeSvolg_TIndirizzoId = 1;
            if (vm.record.SedeEsame_TIndirizzoId == 0) vm.record.SedeEsame_TIndirizzoId = 1;
            if (vm.record.iAnnualita == 0) vm.record.iAnnualita = 4;

            if ((vm.record.SedeSvolg_PaeseId == null || vm.record.SedeSvolg_PaeseId == 0)
                && (vm.record.SedeSvolg_ComuneId == undefined || vm.record.SedeSvolg_ComuneId == null || vm.record.SedeSvolg_ComuneId == 0))
                vm.record.SedeSvolg_ComuneId = '';

            vm.getComuni_Svolg(vm.record.SedeSvolg_ProvinciaId);

            vm.record.PCAllievoChanged = false;
            vm.record.PCDocenteChanged = false;

            vm.record.PCProfProfessionaleChanged = false;
            vm.record.PCDatLavoroChanged = false;
            vm.record.PCSedeChanged = false;
            vm.record.PCRisorsaChanged = false;
            vm.record.PCAulaChanged = false;
            vm.record.PCSupportoChanged = false;

            vm.getModuloSpecSummary(vm.record.PCModSpec4A);
            vm.record.PCModSpec4AChanged = false;

            vm.validPIVA = true;
            vm.validCF = true;
            vm.bMaxOre = true;

            //Azzera filtri
            vm.list.attach = [];
            vm.list.b_attach = false;

            vm.filterAttach = '';
            vm.fAttach.TAttachId = '';

            /*
            // #region Gestione Wizard
            vm.wizardCompleted = false;
            vm.pageWizard = 1;
            vm.lastPageWizard = 1;

            if (pageWiz != null && pageWiz != '' && typeof pageWiz != 'undefined') { //Ho salvato in bozza
                vm.pageWizard = pageWiz;
            }

            if (vm.record.PCDocenti != null && vm.record.PCDocenti.length > 0) {
                vm.wizardCompleted = true;
            }

            if (vm.record.Completed || vm.wizardCompleted) {
                vm.pageWizard = vm.pageMaxWizard;
                vm.lastPageWizard = vm.pageMaxWizard;
            }

            stepCompiled(vm.pageWizard - 1);
            // #endregion
            */

            // #region New Wizard
            vm.wizardCompleted = false;
            vm.pageWizard = 1;

            if (vm.record.PCProfiliProfessionali != null && vm.record.PCProfiliProfessionali.length > 0) {
                vm.pageWizard = 2;
            }
            if (vm.record.PCDatoriLavoro != null && vm.record.PCDatoriLavoro.length > 0) {
                vm.pageWizard = 3;
            }
            if (vm.record.PCSedi != null && vm.record.PCSedi.length > 0) {
                vm.pageWizard = 4;
            }
            if (vm.record.M4A_Certificazione != null && vm.record.M4A_Certificazione.length > 0) {
                vm.pageWizard = 5;
            }
            if (vm.record.PCRisorse != null && vm.record.PCRisorse.length > 0) {
                vm.pageWizard = 6;
            }
            if (vm.record.PCAule != null && vm.record.PCAule.length > 0) {
                vm.pageWizard = 7;
            }
            if (vm.record.PCSupporti != null && vm.record.PCSupporti.length > 0) {
                vm.pageWizard = 8;
            }
            if (vm.record.PCModSpec4A != null && vm.record.PCModSpec4A.length > 0 ||
                vm.record.M4A_MisureAccompagnamento != null && vm.record.M4A_MisureAccompagnamento.length > 0 ||
                vm.record.M4A_bModuliSpecifici) {
                vm.pageWizard = 9;
            }
            if (vm.record.PCDocenti != null && vm.record.PCDocenti.length > 0) {
                vm.pageWizard = 10;
            }
            if (vm.record.PCAllievi != null && vm.record.PCAllievi.length > 0) {
                vm.pageWizard = 11;
                vm.wizardCompleted = true;
            }

            if (vm.record.Completed || vm.wizardCompleted) {
                vm.pageWizard = vm.pageMaxWizard;
            }

            if (pageWiz != null && pageWiz != '' && typeof pageWiz != 'undefined') { //Ho salvato in bozza
                vm.pageWizard = pageWiz;
            }

            //Coloro i numeri in alto a dx
            vm.lastPageWizard = vm.pageWizard;

            // #endregion

            getListAttach(vm.record.Id);

            //console.info('setRecord()', vm.record);
        }

        function getRecord(id, index) {
            return datacontext.pCorso_get(id).then(function (data) {
                vm.index = index;
                setRecord(data);

                setView('detail');
            });
        }

        function goNext() {
            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getByFilter();
            }
            if (!vm.records) return;

            vm.index++;
            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function goPrev() {
            if (vm.index == 0) return;
            if (!vm.records) return;

            vm.index--;

            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        // #region GESTIONE WIZARD
        function PrevWizard(recordForm) {
            if (vm.record.Completed && !vm.isSUPER)
                return;

            if (vm.pageWizard <= 1) return;
            vm.pageWizard--;

            return vm.pageWizard;
        }

        function NextWizard(recordForm) {
            if (typeof recordForm != 'undefined' || recordForm != null) {
                if (recordForm.$invalid) return;
            }
            if (vm.pageWizard >= vm.pageMaxWizard) return;


            vm.pageWizard++;
            vm.lastPageWizard = vm.pageWizard;

            if (vm.pageWizard == vm.pageMaxWizard)
                vm.wizardCompleted = true;



            return vm.pageWizard;
        }


        function setPageWizard(value) {
            if ((vm.record.Completed || !vm.stepCompiled(value)) && !vm.isSUPER)
                return;

            if (value > vm.lastPageWizard)
                return;

            vm.pageWizard = value;
        }

        function stepCompiled(value) {
            if (value < vm.pageWizard)
                return true;
            for (var locPageWizard = vm.pageWizard; locPageWizard < value; locPageWizard++) {
                var retVal = false;

                switch (locPageWizard) {
                    case 2:
                        if (vm.record.PCProfiliProfessionali != null && vm.record.PCProfiliProfessionali.length > 0)
                            retVal = true;
                        break;
                    case 3:
                        if (vm.record.PCDatoriLavoro != null && vm.record.PCDatoriLavoro.length > 0)
                            retVal = true;
                        break;
                    case 4:
                        if (vm.record.PCSedi != null && vm.record.PCSedi.length > 0)
                            retVal = true;
                        break;
                    case 6:
                        if (vm.record.PCRisorse != null && vm.record.PCRisorse.length > 0)
                            retVal = true;
                        break;
                    case 7:
                        if (vm.record.PCAule != null && vm.record.PCAule.length > 0)
                            retVal = true;
                        break;
                    case 8:
                        if (vm.record.PCSupporti != null && vm.record.PCSupporti.length > 0)
                            retVal = true;
                        break;
                    case 9:
                        if (vm.record.PCModSpec4A != null && vm.record.PCModSpec4A.length > 0)
                            retVal = true;
                        break;
                    case 10:
                        if (vm.record.PCDocenti != null && vm.record.PCDocenti.length > 0)
                            retVal = true;
                        break;
                    case 11:
                        if (vm.record.PCAllievi != null && vm.record.PCAllievi.length > 0)
                            retVal = true;
                        break;
                    default:
                        retVal = true;
                        break;
                }

                if (!retVal)
                    return false;
            }
            return true;
        }

        // #endregion

        vm.change_articolato = function () {
            if (vm.record.M4A_bArticolato) {
                //console.log('vm.change_articolato()');
                if (vm.record.PCProfiliProfessionali != null && (vm.record.PCProfiliProfessionali.length == 1 || vm.record.PCProfiliProfessionali.length > 2)) {
                    //console.log('msg');
                    var msg = 'Si ricorda che un corso "articolato" pu\xF0 accogliere n. 2 figure professionali, si veda Art. 6, comma 6 dell\'Avviso. ';
                    bDialog.informationDialog(msg);
                }
            }
            /*
            else {
                if (vm.record.PCProfiliProfessionali != null && vm.record.PCProfiliProfessionali.length > 1) {
                    var msg = 'Si ricorda che un corso "non articolato" pu\xF0 accogliere n. 1 figura professionale, si veda Art. 6, comma 6 dell\'Avviso. ';
                    bDialog.informationDialog(msg);
                }
            }
            */
        };

        vm.change_modSpec = function () {
            if (!vm.record.M4A_bModuliSpecifici) {
                bDialog.confirmationDialog('Conferma', 'Attenzione, i moduli specifici inseriti e la descrizione delle misure di accompagnamento verranno cancellate, procedere? ').then(
                    function () { //YES
                        vm.record.M4A_MisureAccompagnamento = '';
                        vm.record.PCModSpec4A.forEach(function (item) {
                            item.CorsoId = vm.record.Id;
                            item.Deleted = 1;
                        });
                        vm.sumOreTotaliSpec = 0;
                    },
                    function () { //NO
                        vm.record.M4A_bModuliSpecifici = true;
                    }
                );
            }
        };

        function addRecord(id) {
            return datacontext.pCorso_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            changeDurata();
            return datacontext.pCorso_update(vm.record).then(function (data) {
                if (data == "400") {
                    logError('Si \xE8 verificato un errore. ');
                    return 400;
                }
                if (data == "409") return logError('Errore! Nome Corso esistente!!');
                if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                if ($.isNumeric(data)) return logError('Errore server!');

                setRecord(data);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function mergeItem() {
            changeDurata();
            return datacontext.pCorso_merge(vm.record).then(function (data) {
                if (data == "400") {
                    logError('Si \xE8 verificato un errore. ');
                    return 400;
                }
                if (data == "409") return logError('Errore! Nome Corso esistente!!');
                if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                if ($.isNumeric(data)) return logError('Errore server!');

                setRecord(data, vm.pageWizard);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' Percorso: ' + item.NomeCorso;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pCorso_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;

                    return logSuccess('Record cancellato ');
                });
            });
        }

        vm.setCompleted = function () {
            if (!vm.record.Completed)
                bDialog.confirmationDialog('Salva e convalida', 'Attenzione, si sta "SALVANDO e CONVALIDANDO" il percorso. Successivamente, non sar\xE0 possibile apportare modifiche. Si desidera procedere?', 'Procedi').then(
                    function () { //YES
                        vm.record.Completed = true;
                        return datacontext.pCorso_merge(vm.record).then(function (data) {
                            if (typeof data == undefined || $.isNumeric(data)) {
                                vm.record.Completed = false;
                                if ($.isNumeric(data)) {
                                    var msg = 'Attenzione, si \xE8 verificato un errore che ha impedito il salvataggio, ';
                                    switch (data) {
                                        case -2:
                                            msg += 'il numero di allievi deve essere compreso tra "18" e "27" (wiz. 1). ';
                                            break;
                                        case -3:
                                            msg += 'il numero di allievi non coincide con il numero dichiarato (wiz. 4). ';
                                            break;
                                        case -4:
                                            msg += 'il numero di ore eccede il massimo previsto (wiz. 1). ';
                                            break;
                                        case -5:
                                            msg += 'il numero di mesi eccede il massimo previsto (max 12 - wiz. 1). ';
                                            break;
                                        case -6:
                                            msg += 'la somma delle ore di Area 1 e Area 2 eccede le ore totali (wiz. 2). ';
                                            break;
                                        case -7:
                                            msg += 'la somma delle ore di Area 2a e Area 2b eccede le ore di Area 2 (wiz. 2). ';
                                            break;
                                        case -8:
                                            msg += 'la somma totale delle ore dei moduli deve corrispondere a quella del corso (wiz. 3). ';
                                            break;
                                        case -9:
                                            msg += 'non sono presenti docenti (wiz. 5). ';
                                            break;
                                        case -10:
                                            msg += 'non sono presenti moduli (wiz. 3). ';
                                            break;
                                    }
                                    return bDialog.informationDialog(msg);
                                }
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
        };

        vm.unlock = function () {
            var item = vm.record;
            var msg = 'Percorso ID:' + item.Id + ' - ' + item.Titolo;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare il ' + msg + ' ?', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_unlock(item).then(function (data) {
                        if (data == "400") return logError('Errore: operazione non consentita');

                        vm.record.Completed = false;
                        vm.records[vm.index].Completed = vm.record.Completed;

                        return logSuccess('Record sbloccato ');
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        vm.restore = function (item) {
            bDialog.confirmationDialog('Attenzione', 'Si stanno per reinizializzare i campi ricevuta e protocollo. Proseguire?', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_restore(item.Id).then(function (data) {
                        if (data == 0 || data == null || data == '' || typeof data == 'undefined') {
                            return logError('Error on Restore');
                        }

                        item.ProgressivoRicvevuta = 0;
                        item.CodiceRicvevuta = '';
                        item.DtRicvevuta = '';
                        item.NumProtSent = '';
                        item.OpProtSent = '';
                        item.DtProtSent = '';

                        var index = vm.records.indexOf(item);
                        if (index !== -1) {
                            vm.records[index] = item;
                        }

                        return logSuccess('Success on Restore');
                    });
                },
                function () { //NO

                }
            );
        };

        vm.setSent = function () {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti. Procedere?', 'SI').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return datacontext.pCorso_setSent(vm.record.Id).then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data) || typeof data == 'undefined') {
                                vm.record.Sent = false;
                                if (data == "400") return 400;
                                else if (data == "404") return 404;
                                else if (data == "406") {
                                    if (vm.fTMisuraCode == '5' || vm.fTMisuraCode == '2C' || vm.fTMisuraCode == '2B' || vm.fTMisuraCode == '4A')
                                        return logError('Attenzione: inserire tutti gli allegati richiesti, prima di procedere.');
                                }
                                else if (data == "417") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                                else if (data == "502") {
                                    return logError('Attenzione: la stampa della "ricevuta" non \xE8 ancora permessa, in quanto non \xE8 il periodo utile.');
                                }

                                return true;
                            }
                            vm.printRicevuta();
                            getRecord(data.Id, vm.index);
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                vm.printRicevuta();
            }
        };

        vm.unlockSent = function () {
            if (vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'Si vuole rimuovere lo stato in "Ricevuta". Ma l\'assegnazione del codice rimmarr\xE0 a sistema. Procedere?', 'SI').then(
                    function () { //YES
                        return datacontext.pCorso_unlockSent(vm.record).then(function (data) {
                            //console.info('unlockSent()', data);
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.record.Sent = false;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
        };

        vm.setProtSent = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcProtSent.html?version=127',
                controller: '4a_pcProtSent',
                backdrop: 'static',
                resolve: {
                    pCorso: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore. ');

                setRecord(returnItem);
                vm.records[index] = vm.record;
                logSuccess('Istanza protocollata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetProtSent = function (item, index) {
            if (item.NumProtSent != null && item.NumProtSent != "") {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo il protocollo dell\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        return datacontext.pCorso_unsetProtSent(item).then(function (data) {
                            if (data == '404') return logError('Errore di aggiornamento stato. ');
                            if (typeof data == 'undefined') return logError('Errore. ');

                            setRecord(data);
                            return vm.records[index] = vm.record;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.setConvalida = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcConvalida.html?version=127',
                controller: '4a_pcConvalida',
                backdrop: 'static',
                resolve: {
                    pCorso: function () {
                        return item;
                    },
                    tMisuraCode: function () {
                        return item.TMisuraCode;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return logError('Errore Aggiornamento');
                if (!returnItem) return logError('Errore. ');

                setRecord(returnItem);
                vm.records[index] = vm.record;
                logSuccess('Istanza convalidata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetConvalida = function (item, index) {
            if (item.iConvalida != 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo la convalida dall\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        item.iConvalida = 0;
                        return datacontext.pCorso_unsetConvalida(item).then(function (data) {
                            if (typeof data == 'undefined') return logError('Errore. ');

                            setRecord(data);
                            return vm.records[index] = vm.record;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        //Elenchi Parametri
        function getAPL() {
            vm.cmblist.APL = [];
            return datacontext.azienda_getAllList('', '', 0, '', 'PROM', vm.fTMisuraCode, 0, 0, 0, '', '', '', 0).then(function (data) {
                return vm.cmblist.APL = data;
            });
        }

        function getTRisorse() {
            if (vm.cmblist.cndTRisorse.length > 0) return;

            return datacontext.cndTRisorsa_getAllList().then(function (data) {
                return vm.cmblist.cndTRisorse = data;
            });
        }

        function getTAule() {
            if (vm.cmblist.cndTAule.length > 0) return;

            return datacontext.cndTAula_getAllList().then(function (data) {
                return vm.cmblist.cndTAule = data;
            });
        }

        function getTAteco() {
            if (vm.cmblist.tAteco.length > 0) return;

            return datacontext.tAteco_getAllList().then(function (data) {
                return vm.cmblist.tAteco = data;
            });
        }

        function getTFigProfessionali() {
            if (vm.cmblist.tFigProfessionali.length > 0) return;

            return datacontext.tFigProfessionale_getAll('IeFP4').then(function (data) {
                console.info('tFigProfessionali[]', data);
                return vm.cmblist.tFigProfessionali = data;
            });
        }

        function getSettProfessionali() {
            if (vm.cmblist.settProfessionali.length > 0) return;

            return datacontext.settProfess_getAllList().then(function (data) {
                return vm.cmblist.settProfessionali = data;
            });
        }

        function getTProfiliDocenti() {
            if (vm.cmblist.tProfiloDocenti.length > 0) return;

            datacontext.tProfiloDocente_getAll().then(function (data) {
                vm.cmblist.tProfiloDocenti = data;
            });
        }

        function getTTitoloStudio() {
            if (vm.cmblist.tTitoloStudio.length > 0) return;

            datacontext.tTitoloStudio_getAllList().then(function (data) {
                vm.cmblist.tTitoloStudio = data;
            });
        }

        function getEnte1() {
            return datacontext.azienda_getAllList('', '', 0, '', 'OSP', vm.fTMisuraCode, 0, 0, 0, '', '', 0).then(function (data) {
                return vm.cmblist.ente1 = data;
            });
        }

        function getEnte2() {
            return datacontext.azienda_getAllList('', '', 0, '', 'OSP', vm.fTMisuraCode, 0, 0, 0, '', '', 0).then(function (data) {
                return vm.cmblist.ente2 = data;
            });
        }


        // ENTE CERTIFICATORE
        vm.reset_EnteCertificatore = function () {
            if (!vm.record.bEnteCertificatore) {
                vm.record.EnteCertif_RagioneSociale = '';
                vm.record.EnteCertif_PIVA = '';
                vm.record.EnteCertif_CF = '';
            }
        };

        // #region Partecipazione Corso Risorsa

        vm.addPCRisorsa = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcRisorsaAdd.html?version=127',
                controller: '4a_pcRisorsaAdd',
                backdrop: 'static',
                resolve: {
                    pcRisorsa: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    cndTRisorse: function () {
                        return vm.cmblist.cndTRisorse;
                    },
                    tTitoloStudio: function () {
                        return vm.cmblist.tTitoloStudio;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCRisorse.push(returnItem);
                }
                else {
                    var index = vm.record.PCRisorse.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCRisorse[index] = returnItem;
                    }
                }

                vm.record.PCRisorsaChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCRisorsa = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCRisorsaChanged = true;
            return logSuccess('Elemento rimosso ');
        };



        // #endregion

        // #region Partecipazione Corso Aula

        vm.addPCAula = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcAulaAdd.html?version=127',
                controller: '4a_pcAulaAdd',
                backdrop: 'static',
                resolve: {
                    pcAula: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    cndTAule: function () {
                        return vm.cmblist.cndTAule
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCAule.push(returnItem);
                }
                else {
                    var index = vm.record.PCAule.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCAule[index] = returnItem;
                    }
                }

                vm.record.PCAulaChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCAula = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCAulaChanged = true;
            return logSuccess('Elemento rimosso ');
        };



        // #endregion

        // #region Partecipazione Corso Supporto

        vm.addPCSupporto = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcSupportoAdd.html?version=127',
                controller: '4a_pcSupportoAdd',
                backdrop: 'static',
                resolve: {
                    pcSupporto: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    sedi: function () {
                        return vm.record.PCSedi;
                    },
                    aziende: function () {
                        return vm.cmblist.aziende;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCSupporti.push(returnItem);
                }
                else {
                    var index = vm.record.PCSupporti.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCSupporti[index] = returnItem;
                    }
                }

                vm.record.PCSupportoChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCSupporto = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCSupportoChanged = true;
            return logSuccess('Elemento rimosso ');
        };



        // #endregion

        // #region Corso Modulo Specifici

        vm.addCorsoModSpec = function (item) {
            if (item) item.Deleted = false;
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcModuloAdd.html?version=127',
                controller: '4a_pcModuloAdd',
                backdrop: 'static',
                resolve: {
                    modulo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCModSpec4A.push(returnItem);
                }
                else {
                    var index = vm.record.PCModSpec4A.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCModSpec4A[index] = returnItem;
                    }
                }

                vm.getModuloSpecSummary(vm.record.PCModSpec4A);
                vm.record.PCModSpec4AChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoModSpec = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCModSpec4AChanged = true;
            vm.getModuloSpecSummary(vm.record.PCModSpec4A);
            return logSuccess('Elemento rimosso ');
        };

        vm.getModuloSpecSummary = function (array) {
            vm.sumOreTotaliSpec = 0;

            if (typeof array == 'undefined' || array.length == 0)
                return;
            return array.forEach(function (item) {
                if (!item.Deleted) {
                    vm.sumOreTotaliSpec += item.M4A_Ore;
                }

                return true;
            });
        };


        // #endregion

        // #region Corso Docente

        vm.addCorsoDocente = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcDocenteAdd.html?version=127',
                controller: '4a_pcDocenteAdd',
                backdrop: 'static',
                resolve: {
                    docente: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    cndPCMod: function () {
                        return vm.record.PCMod;
                    },
                    tProfiloDocenti: function () {
                        return vm.cmblist.tProfiloDocenti;
                    },
                    tTitoloStudio: function () {
                        return vm.cmblist.tTitoloStudio;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCDocenti.push(returnItem);
                }
                else {
                    var index = vm.record.PCDocenti.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCDocenti[index] = returnItem;
                    }
                }

                vm.record.PCDocenteChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoDocente = function (item) {
            item.Deleted = true;
            item.OpDeleted = vm.record.OpInsert;
            vm.record.PCDocenteChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion

        // #region Corso Allievo

        vm.addCorsoAllievo = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcAllievoAdd.html?version=127',
                controller: '4a_pcAllievoAdd',
                backdrop: 'static',
                resolve: {
                    allievo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    enti1: function () {
                        return vm.cmblist.enti1;
                    },
                    enti2: function () {
                        return vm.cmblist.enti2;
                    },
                    tMisuraCode: function () {
                        return vm.fTMisuraCode;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCAllievi.push(returnItem);
                }
                else {
                    var index = vm.record.PCAllievi.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCAllievi[index] = returnItem;
                    }
                }

                vm.record.PCAllievoChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoAllievo = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCAllievoChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion

        // #region Corso Profilo Professionale

        vm.addPCProfProfessionale = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcProfProfessionaleAdd.html?version=127',
                controller: '4a_pcProfProfessionaleAdd',
                backdrop: 'static',
                resolve: {
                    profProfessionale: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    tFigProfessionali: function () {
                        return vm.cmblist.tFigProfessionali;
                    },
                    settProfess1Id: function () {
                        return vm.record.M4A_SettProfessionale1Id;
                    },
                    settProfess2Id: function () {
                        return vm.record.M4A_SettProfessionale2Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCProfiliProfessionali.push(returnItem);
                }
                else {
                    var index = vm.record.PCProfiliProfessionali.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCProfiliProfessionali[index] = returnItem;
                    }
                }

                vm.record.PCProfProfessionaleChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCProfProfessionale = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCProfProfessionaleChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion

        // #region Corso Datore Lavoro

        vm.addPCDatLavoro = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcDatoreLavoroAdd.html?version=127',
                controller: '4a_pcDatoreLavoroAdd',
                backdrop: 'static',
                resolve: {
                    datLavoro: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    settProfessionali: function () {
                        return vm.cmblist.settProfessionali;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCDatoriLavoro.push(returnItem);
                }
                else {
                    var index = vm.record.PCDatoriLavoro.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCDatoriLavoro[index] = returnItem;
                    }
                }

                vm.record.PCDatLavoroChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCDatLavoro = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCDatLavoroChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion

        // #region Corso Sede

        vm.addPCSede = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/4a_pcSedeAdd.html?version=127',
                controller: '4a_pcSedeAdd',
                backdrop: 'static',
                resolve: {
                    sede: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    aziende: function () {
                        return vm.list.aziende;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCSedi.push(returnItem);
                }
                else {
                    var index = vm.record.PCSedi.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCSedi[index] = returnItem;
                    }
                }

                vm.record.PCSedeChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCSede = function (item) {
            item.Deleted = true;
            item.OpDelete = vm.record.OpInsert;
            vm.record.PCSedeChanged = true;
            return logSuccess('Elemento rimosso ');
        };


        // #endregion





        // #region STAMPA ALLEGATO 4

        vm.printAllegato = function (index) {
            var msg = '';
            if (!vm.record.Completed) {
                msg = 'L\'allegato verr\xE0 stampato in formato PDF in bozza. Procedere? ';
            }
            else {
                msg = 'L\'allegato verr\xE0 stampato in formato PDF. Procedere? ';
            }
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    vm.printing = true;
                    $('#loadingModal').modal('show');

                    return datacontext.pdf_printAttach2(0, vm.tSourceCode_def, vm.record.Id, 0, index).then(function (response) {
                        vm.printing = false;
                        $('#loadingModal').modal('hide');
                        var status = response.status;
                        var data = response.data;

                        if (response == null || $.isNumeric(status)) {
                            if (status == 417) {
                                return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                            }
                            return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                        }
                        else if (response && response.url) {

                            var url = response.url;
                            var name = 'Allegato' + index + '_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';

                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //a.href = response.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = 'Allegato' + index + '_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';
                            //a.click();
                            //document.body.removeChild(a);

                            return response.url;
                        } else
                            return true;
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        vm.printRicevuta = function () {
            if (vm.record.Sent) {
                $('#loadingModal').modal('show');

                return datacontext.pdf_printRicevuta2(0, vm.tSourceCode_def, vm.record.Id).then(function (response) {
                    $('#loadingModal').modal('hide');
                    var status = response.status;
                    var data = response.data;

                    if (response == null || $.isNumeric(status)) {
                        if (status == 417) {
                            return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                        }
                        return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                    }
                    else if (response && response.url) {

                        var url = response.url;
                        var name = 'RicevutaID' + vm.record.Id + '.pdf';

                        window.open(url, name);

                        //recupero allegato appena creato
                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //a.setAttribute('target', '_blank');
                        //document.body.appendChild(a);

                        //a.href = response.url;
                        //if ($rootScope.detectIE()) {
                        //    a.target = 'hiddenIframe';
                        //}
                        //else
                        //    a.download = 'RicevutaID' + vm.record.Id + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);

                        return response.url;
                    } else
                        return true;
                });
            }
        };

        // #endregion

        // #region PANNELLO ATTACH
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }
        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getListAttach(id) {
            if (!id) return;

            if (vm.fAttach.TAttachId == '' || vm.fAttach.TAttachId == null || typeof vm.fAttach.TAttachId == 'undefined') {
                vm.fAttach.TAttachId = 0;
            }

            return datacontext.attach_getAll(0, 0, id, 0, vm.tSourceCode_def, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;

                return datacontext.tAttachVisibility_getAuth(vm.tSourceCode_def).then(function (data_TAV) {
                    var tAttVis = data_TAV;

                    vm.list.attach.forEach(function (item_A) {
                        var myTAV = _.find(tAttVis, { 'TAttachId': item_A.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        item_A.bRead = myTAV.bRead;
                        item_A.bInsert = myTAV.bInsert;
                        item_A.bUpdate = myTAV.bUpdate;
                        item_A.bDelete = myTAV.bDelete;
                        item_A.iTags = myTAV.iTags;

                        if (!item_A.bRead) {
                            var index = vm.list.attach.indexOf(item_A);
                            vm.list.attach.splice(index, 1);
                        }

                    });

                    return vm.list.attach = data;
                });
            });
        }

        vm.addAttach = function (item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Titolo };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        var tatt = typeof item == 'undefined' ? null : vm.tAttach;
                        return tatt;
                    },
                    tAttachId: function () {
                        var tattid = typeof item == 'undefined' ? null : item.TAttachId;
                        return tattid;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return false;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "417") return logError('Attenzione: entit\xE0 bloccata. ');
                if (returnItem == "401") return logError('Attenzione: azione non autorizzata. ');
                if (returnItem == "406") return logError('Attenzione: allegato non permesso. ');
                if (returnItem == "409") return logError('Attenzione: allegato alterato rispetto all\'originale. ');
                if ($.isNumeric(returnItem)) return logError('Attenzione: errore generico. ');
                //Documenti con hashcode diverso da originale ma non bloccante
                if (returnItem.alert != null) { bDialog.informationDialog(returnItem.alert); }

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteAttach = function (item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: entit\xE0 inesistente. ');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                });
            });
        };



        // #endregion

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi4A/modal/cndPCorso4AAdd.html?version=127',
                controller: 'cndPCorso4AAdd',
                backdrop: 'static',
                resolve: {
                    apl: function () {
                        return vm.cmblist.APL;
                    },
                    aplId: function () {
                        return typeof vm.risorsa == 'undefined' || vm.risorsa == null ? null : vm.risorsa.AziendaId;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                if (returnItem == "409") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                if (returnItem == "400") return logError('Attenzione: raggiunto il numero massimo di corsi ammessi per il Catalogo.');
                if (!returnItem) return logError('errore di creazione! ');

                logSuccess('record creato con successo! ');
                addRecord(returnItem.Id);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }


        function changeDurata() {
            vm.record.Importo = 0;
            if (vm.record.M4A_OreFormazione > 0 && vm.record.M4A_OreTutoraggio > 0 && vm.record.AllieviMax > 0) {
                vm.record.M4A_ImpFormEst = parseFloat((vm.record.M4A_OreFormazione * 73.13).toFixed(2));
                vm.record.M4A_ImpFormEstStd = parseFloat((vm.record.M4A_OreFormazione * vm.record.AllieviMax * 0.80).toFixed(2));
                vm.record.M4A_ImpTutorAz = parseFloat((vm.record.M4A_OreTutoraggio * vm.record.AllieviMax * 40.0).toFixed(2));

                vm.record.Importo = vm.record.M4A_ImpFormEst + vm.record.M4A_ImpFormEstStd + vm.record.M4A_ImpTutorAz;
            }
        }

        // #region VERIFICA PARTITA IVA E CODICE FISCALE

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.checkPIVA = function (value) {
            vm.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            vm.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.checkCF = function (value) {
            vm.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            if (value.length == 11) isEnte = true;
            vm.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return vm.validCF = data;
            });
        };

        // #endregion

    }
})();
